import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import { getGroupsByGame } from './dashboardSlice';

function FindGroupDashboard()
{
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const groups = useSelector((state) => state.dashboard.groups);
  const cookieGameId = Cookies.get("game_id");

  useEffect(()=>{
    dispatch(getGroupsByGame(cookieGameId));
  }, []);

  useEffect(() => { 
    let playerCount = 0;
    let confirmedCount = 0;

    groups.forEach(group => {
      group.players.forEach(player => {
        playerCount++;
        if(player.status === 'confirmed'){
          confirmedCount++;
        }
      });
    });
    if(playerCount !== 0 && confirmedCount === playerCount){
      navigate(`/app/digiboard/scoreBoard/${cookieGameId}${window.location.search}`);
    }
  }, [groups]);

  const allGroupPlayersConfirmed = (players) => {
    let count = 0;
    players.forEach(player => {
      if(player.status === 'confirmed'){
        count++;
      }
    });
    return players.length === count;
  }


  return(
    <div className="dashboard-container find-group-digiboard">
      <div className="content-wrapper">
        <h3>{ t("digiboard.find_group.title") }</h3>
        <div className="group-wrapper">
          {groups && groups.map(group => 
            <div key={group.group_id} className="group-card">
              <div className="avatar-container">
                <ul>
                  {group.players && group.players.map(player =>
                    player.user_assigned == 1 &&
                    <li key={player.id}>
                          <div className={`avatar ${player.avatar ? 'avatar-created': ''} ${player.status === 'confirmed' ? 'confirmed': ''}`}>
                            {player.avatar && <img src={`/storage/avatar/${player.secret}.jpg`} width="80" height="80" />}
                            {!player.avatar && <img src={`/images/default_avatar.png`} width="80" height="80" />}
                          </div>
                    </li>
                  )}
                </ul>
              </div>
              <div className={`group-card-content ${allGroupPlayersConfirmed(group.players) ? 'confirmed' : '' }`}>
                <h5 className="group-name">{group.name}</h5>
                <ul className="player-names">
                  {group.players && group.players.map(player =>
                    player.user_assigned == 1 &&
                    <li className={`${player.status === 'confirmed' ? 'confirmed': ''}`} key={player.id}>{player.name}</li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default FindGroupDashboard;